import { SvgStyled } from '../../components/Global/Atomics/SvgStyled';

const Localization_sm = (props) => {
    const width = props.width ? props.width + 'px' : '20px';
    const height = props.height ? props.height + 'px' : '20px';

    return (
        <SvgStyled
            xmlns="http://www.w3.org/2000/svg"
            version="1.1"
            className={props.cssClasses ? `icon ${props.cssClasses}` : 'icon'}
            viewBox="0 0 20 20"
            fill={props.fill ? props.fill : 'none'}
            customColor={props.customColor}
            width={width}
            height={height}>
            <path
                d="M10 11C10.5523 11 11 10.5523 11 10C11 9.44771 10.5523 9 10 9C9.44771 9 9 9.44771 9 10C9 10.5523 9.44771 11 10 11Z"
            />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M10.75 1.5C10.75 1.08579 10.4142 0.75 10 0.75C9.58579 0.75 9.25 1.08579 9.25 1.5V2.42936C5.64746 2.78192 2.78192 5.64746 2.42936 9.25H1.5C1.08579 9.25 0.75 9.58579 0.75 10C0.75 10.4142 1.08579 10.75 1.5 10.75H2.42936C2.78192 14.3525 5.64746 17.2181 9.25 17.5706V18.5C9.25 18.9142 9.58579 19.25 10 19.25C10.4142 19.25 10.75 18.9142 10.75 18.5V17.5706C14.3525 17.2181 17.2181 14.3525 17.5706 10.75H18.5C18.9142 10.75 19.25 10.4142 19.25 10C19.25 9.58579 18.9142 9.25 18.5 9.25H17.5706C17.2181 5.64746 14.3525 2.78192 10.75 2.42936V1.5ZM3.93845 9.25C4.27806 6.47672 6.47672 4.27806 9.25 3.93845V5.5C9.25 5.91421 9.58579 6.25 10 6.25C10.4142 6.25 10.75 5.91421 10.75 5.5V3.93845C13.5233 4.27806 15.7219 6.47672 16.0615 9.25H14.5C14.0858 9.25 13.75 9.58579 13.75 10C13.75 10.4142 14.0858 10.75 14.5 10.75H16.0615C15.7219 13.5233 13.5233 15.7219 10.75 16.0615V14.5C10.75 14.0858 10.4142 13.75 10 13.75C9.58579 13.75 9.25 14.0858 9.25 14.5V16.0615C6.47672 15.7219 4.27806 13.5233 3.93845 10.75H5.5C5.91421 10.75 6.25 10.4142 6.25 10C6.25 9.58579 5.91421 9.25 5.5 9.25H3.93845Z"
            />
        </SvgStyled>
    );
};

export default Localization_sm;
